<template>
  <v-container py-0>
    <v-progress-linear
      :active="loading"
      height="3"
      :indeterminate="true"
      class="my-1"
    />
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-toolbar flat dense color="transparent">
            <v-spacer />
            <dialog-upload />
          </v-toolbar>
          <v-container v-if="galery && galery.length" grid-list-sm fluid>
            <v-layout row wrap>
              <v-flex
                v-for="(file, index) in galery"
                :key="file._id"
                xs12
                md3
                d-flex
                class="cursor"
              >
                <v-card flat>
                  <v-img
                    v-if="file.type === 'userImage'"
                    :ref="'img' + index"
                    :src="file.path"
                    aspect-ratio="1"
                    class="grey lighten-2 cursor"
                    @click="openFile(file)"
                    @error="onImgError('img' + index)"
                  >
                    <template #placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        />
                      </v-layout>
                    </template>
                  </v-img>
                  <video
                    v-else-if="file.type === 'userVideo'"
                    :src="file.path"
                    width="100%"
                    style="min-witdh: '100%'; min-height: '100%'"
                    controls
                  />

                  <v-card-actions>
                    <v-spacer />
                    <button-confirm
                      color="error"
                      icon="delete"
                      flat
                      :text="$t('action.buttons.delFile')"
                      :disabled="loading"
                      @submit="_deleteFile(file.path)"
                    />
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <dialog-image :dialog.sync="dialogImage" :image="image" />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import ButtonConfirm from '@/components/widgets/button/ButtonConfirm'
import DialogImage from '@/components/widgets/dialog/DialogImage'
import DialogUpload from '@/components/widgets/dialog/DialogUpload'
export default {
  name: 'TabGalery',
  components: {
    DialogImage,
    DialogUpload,
    ButtonConfirm,
  },
  props: {
    galery: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      file: '',
      dialogImage: false,
      image: '',

      dialogVideo: false,
      video: '',

      dialogUpload: false,

      cdnDelete: '',
      dialogDelete: false,
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.users.loading,
      userId: (state) => state.users.idSelected,
      loadingFile: (state) => state.files.loading,
    }),
    ...mapGetters({
      teamPositions: 'teams/teamPositions',
      playerFoot: 'users/playerFoot',
    }),
    localProfile: {
      get() {
        return this.profile
      },
      set(value) {
        this.$emit('update:profile', value)
      },
    },
  },
  methods: {
    ...mapActions({
      deleteFile: 'files/deleteGaleryFile',
    }),
    openFile(file) {
      if (file.type === 'userImage') {
        this.image = file.path
        this.dialogImage = true
      } else if (file.type === 'userVideo') {
        this.video = file.path
        this.dialogVideo = true
      }
    },
    _deleteFile(cdn) {
      let payload = {
        userId: this.userId,
        cdn,
      }
      this.deleteFile(payload).then(() => {
        this.DialogDelete = false
      })
    },
    clear() {
      this.$validator.reset()
    },
  },
}
</script>
<style>
video {
  object-fit: fill;
}
</style>
